module.exports = __webpack_public_path__ + "img/icecream_dessert.be5030ca.webp";